import useSWR from "swr"
import { Table } from "antd"

import { fetcher } from "../../../../api"
import { buildIssuersTableColumns } from "./issuers-table-columns"

interface Props {
  tenantId: number
}

export const Issuers = ({ tenantId }: Props) => {
  const { data: kyc } = useSWR(`/kyc?tenantId=${tenantId}`, fetcher)
  
  return (
    <Table
      columns={buildIssuersTableColumns()}
      dataSource={kyc}
      loading={!kyc}
      rowKey="id"
      size="small"
    />
  )
}